import { getCanvassingSessionTimestampPresentation } from './canvassingSessionFormatters';

export const CanvassingSessionTimestamp = ({ timestamp }: { timestamp: unknown }) => {
  const presentation = getCanvassingSessionTimestampPresentation(timestamp);
  if (presentation === null) return <>—</>;

  return (
    <time dateTime={presentation.dateTime} title={presentation.accessible} aria-label={presentation.accessible}>
      {presentation.display}
    </time>
  );
};
